import React, { useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import {
  isAuthenticated,
  getUserRole,
  requiresPasswordChange,
} from "../utils/authStorage";

const ProtectedRoute = ({ element: Component, requiredRole, ...rest }) => {
  const authenticated = isAuthenticated();
  const userRole = getUserRole();
  const mustChangePassword = requiresPasswordChange();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handlePopState = () => {
      if (!isAuthenticated()) {
        navigate("/");
      }
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate]);

  if (!authenticated) return <Navigate to="/" state={{ from: location }} />;

  if (!requiredRole.includes(userRole)) {
    return <Navigate to="/" state={{ from: location }} />;
  }

  if (mustChangePassword && location.pathname !== "/change-password") {
    return <Navigate to="/change-password" replace state={{ forced: true }} />;
  }

  return <Component {...rest} />;
};

export default ProtectedRoute;
